
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h3l1.82 4.967c.231.663.417 1.389.632 2.083h.078c.231-.694.416-1.419.632-2.083L7.922 0h3.045v11.75h-2.35V7.959c.049-1.354.18-2.704.393-4.042h-.082L7.914 6.706l-1.636 4.261h-1.6L3.026 6.706l-.982-2.789h-.065a37.12 37.12 0 01.376 4.042v3.791H0V0zM14.434 0h2.1l2.265 7.05h-1.853l-.419-1.567h-2.143l-.418 1.567h-1.8L14.434 0zm.285 4.7h1.471l-.155-1.058c-.193-.691-.378-1.522-.571-2.075h-.038c-.175.572-.368 1.384-.551 2.075L14.719 4.7z"}})])
          )
        }
      }
    